import { render, staticRenderFns } from "./Fade.vue?vue&type=template&id=0f523319&lang=pug&"
import script from "./Fade.vue?vue&type=script&lang=js&"
export * from "./Fade.vue?vue&type=script&lang=js&"
import style0 from "./Fade.vue?vue&type=style&index=0&id=0f523319&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports